import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { selectAll, updatePlatformCheckbox, orgInitialState } from 'redux/modules/groupPostCompose';
import { FormSection, PageHeader } from 'components';
import * as styles from './Group.scss';
var GPostToArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    allSelected: state.groupPostCompose.allSelected,
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    allClients: state.teamManagement.allClients
  };
}, {
  selectAll: selectAll,
  updatePlatformCheckbox: updatePlatformCheckbox
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GPostToArea, _Component);

  var _super = _createSuper(GPostToArea);

  function GPostToArea() {
    var _this;

    _classCallCheck(this, GPostToArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleCheck", function (e, checked, orgId) {
      _this.props.updatePlatformCheckbox(e.target.id.split('_')[0], checked, orgId);
    });

    _defineProperty(_assertThisInitialized(_this), "mapPlatformToIcon", function (platform, unlinked) {
      switch (platform) {
        case 'LinkedIn company':
          return /*#__PURE__*/React.createElement("i", {
            className: "fa fa-linkedin-square",
            style: {
              color: '#007bb5',
              fontSize: 18,
              marginRight: 12,
              opacity: "".concat(unlinked ? '0.5' : '1')
            }
          });

        case 'LinkedIn profile':
          return /*#__PURE__*/React.createElement("i", {
            className: "fa fa-linkedin-square",
            style: {
              color: '#007bb5',
              fontSize: 18,
              marginRight: 12,
              opacity: "".concat(unlinked ? '0.5' : '1')
            }
          });

        case 'Twitter':
          return /*#__PURE__*/React.createElement("i", {
            className: "fa fa-twitter-square",
            style: {
              color: '#1da1f2',
              fontSize: 18,
              marginRight: 12,
              opacity: "".concat(unlinked ? '0.5' : '1')
            }
          });

        default:
          return /*#__PURE__*/React.createElement("i", {
            className: "fa fa-facebook-square",
            style: {
              color: '#3b5998',
              fontSize: 18,
              marginRight: 12,
              opacity: "".concat(unlinked ? '0.5' : '1')
            }
          });
      }
    });

    return _this;
  }

  _createClass(GPostToArea, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          allClients = _this$props.allClients,
          groupPost = _this$props.groupPost;
      var clientsWithSocialAccounts = allClients.filter(function (client) {
        return client.SocialAccounts && !!client.SocialAccounts.length;
      });
      var checkboxes = clientsWithSocialAccounts.map(function (client, index) {
        return /*#__PURE__*/React.createElement("div", {
          "data-tip": true,
          "data-for": groupPost.selectedAccounts[client.organization_id] && groupPost.selectedAccounts[client.organization_id].unlinked ? 'gpostTooltip' : '',
          className: styles.postToRow,
          key: "".concat(client.id, "_saRow")
        }, /*#__PURE__*/React.createElement("h4", {
          className: styles.postToRowTitle,
          style: groupPost.selectedAccounts[client.organization_id] && groupPost.selectedAccounts[client.organization_id].unlinked ? {
            cursor: 'pointer',
            opacity: 0.5
          } : {}
        }, client.name, /*#__PURE__*/React.createElement(ReactTooltip, {
          id: 'gpostTooltip',
          effect: "solid",
          place: "left"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 2
          }
        }, "This location edited the group post."))), client.SocialAccounts.map(function (sa) {
          var platformName = _.camelCase(sa.platform);

          if (platformName === 'facebookProfile') {
            return null;
          }

          var selected = groupPost.selectedAccounts[client.id] && groupPost.selectedAccounts[client.id][platformName];
          var unlinked = groupPost.selectedAccounts[client.id] && groupPost.selectedAccounts[client.id].unlinked;

          var icon = _this2.mapPlatformToIcon(sa.platform, unlinked);

          return /*#__PURE__*/React.createElement(Checkbox, {
            label: [icon, sa.username],
            id: "".concat(platformName, "_").concat(client.id),
            checked: selected,
            onCheck: function onCheck(e, checked) {
              return _this2.handleCheck(e, checked, client.id);
            },
            disabled: unlinked
          });
        }));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: styles.postToWrap,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.postToRow
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: this.props.allSelected ? 'Unselect All' : 'Select All',
        id: "selectAllCheckbox",
        checked: this.props.allSelected,
        onCheck: function onCheck(e, checked) {
          _this2.props.selectAll(clientsWithSocialAccounts, checked);
        }
      })), checkboxes);
    }
  }]);

  return GPostToArea;
}(Component)) || _class);
export { GPostToArea as default };